import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Text } from '@rtkwlf/c3-core-react';
import { Button } from '@rtkwlf/fenrir-react';
import { faRotateRight } from '@rtkwlf/pro-solid-svg-icons/faRotateRight';

import { useSecurityJourneyTranslations } from '../../../../../locales/use-security-journey-translations';

import styles from './security-focus-timeline-item-error.module.css';

type SecurityFocusTimelineItemErrorProps = {
  description: string;
  icon: React.ReactNode;
  onRetry: () => void;
};

export const SecurityFocusTimelineItemError: React.FunctionComponent<
  SecurityFocusTimelineItemErrorProps
> = ({ description, icon, onRetry }) => {
  /**
   * Get an instance of the translations
   */
  const { t } = useSecurityJourneyTranslations();

  return (
    <div
      className={styles['sft-item-error']}
      data-testid="security-focus-timeline-item-error"
    >
      {icon}
      <Text align="center" contrast="medium">
        {description}
      </Text>
      <Button
        iconLeft={<FontAwesomeIcon icon={faRotateRight} />}
        variant="link"
        onClick={onRetry}
      >
        {t('common:retry')}
      </Button>
    </div>
  );
};
